import React from "react";
import ChatBubble from "../ChatBubble";

const testimonials = [
  {
    text:
      "Olin aiemmin käyttänyt muita harjoituksia onnetta, mutta kun löysin ajokaistan, niin vihdoin ja viimein sain teoriakokeen valmiiksi.",
    author: "Jasu M.",
    date: "19.12.2025",
  },
  {
    text: "Tosi hyvä pääsin ekalla läpi.",
    author: "A. Toljamo",
    date: "11.9.2025",
  },
  {
    text:
      "Sisältö on tiivis, selkeä ja siitä löytyy kaikki olennainen. Harjoittelutehtävät ovat hyviä ja tämän teoriakoe samanlainen kuin oikea koe. Pääsin kirkkaasti läpi teoriakokeen. Hinta on kohtuullinen. :-)",
    author: "Anette V.",
    date: "20.8.2025",
  },
  {
    text: "Loistava harjoittelusovellus. Ekalla be koe läpi.",
    author: "M. Hiltunen",
    date: "24.7.2025",
  },
];

const BubbleList = ({ limit }) => (
  <div>
    {(limit ? testimonials.slice(0, limit) : testimonials).map((t, idx) => (
      <div key={idx} className={idx % 2 === 1 ? "pull-right" : undefined}>
        <ChatBubble>
          <p>
            <span>{t.text}</span>
            <br />
            <i>
              {t.author}, {t.date}
            </i>
          </p>
        </ChatBubble>
      </div>
    ))}
  </div>
);

export const WebShopTestimonialsMobile = ({ hidden }) => {
  if (hidden) return null;
  return (
    <div className="medium-top-margin medium-bottom-margin">
      <BubbleList limit={1} />
    </div>
  );
};

export const WebShopTestimonials = ({ hidden }) => {
  if (hidden) return null;
  return (
    <div className="medium-top-margin medium-bottom-margin fade-in longer-delay">
      <BubbleList />
    </div>
  );
};

export default WebShopTestimonials;
